/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeatureListFragment, FeatureListFragment, FullFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list';

/**
 * Get a single FeatureList by ID (base - scalars only)
 */
export const getBaseFeatureListById = gql`
  ${BaseFeatureListFragment}

  query GetBaseFeatureListById($id: String!, $locale: String!, $preview: Boolean) {
    featureList(id: $id, locale: $locale, preview: $preview) {
      ...BaseFeatureListFragment
    }
  }
`;

/**
 * Get a single FeatureList by ID (standard - 1 level deep)
 */
export const getFeatureListById = gql`
  ${FeatureListFragment}

  query GetFeatureListById($id: String!, $locale: String!, $preview: Boolean) {
    featureList(id: $id, locale: $locale, preview: $preview) {
      ...FeatureListFragment
    }
  }
`;

/**
 * Get a single FeatureList by ID (full - 2 levels deep)
 */
export const getFullFeatureListById = gql`
  ${FullFeatureListFragment}

  query GetFullFeatureListById($id: String!, $locale: String!, $preview: Boolean) {
    featureList(id: $id, locale: $locale, preview: $preview) {
      ...FullFeatureListFragment
    }
  }
`;

/**
 * Get all FeatureList entries with pagination (base - scalars only)
 */
export const getBaseFeatureLists = gql`
  ${BaseFeatureListFragment}

  query GetBaseFeatureLists(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureListOrder]
    $where: FeatureListFilter
    $preview: Boolean
  ) {
    featureListCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFeatureListFragment
      }
    }
  }
`;

/**
 * Get all FeatureList entries with pagination (standard - 1 level deep)
 */
export const getFeatureLists = gql`
  ${FeatureListFragment}

  query GetFeatureLists(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureListOrder]
    $where: FeatureListFilter
    $preview: Boolean
  ) {
    featureListCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FeatureListFragment
      }
    }
  }
`;

/**
 * Get all FeatureList entries with pagination (full - 2 levels deep)
 */
export const getFullFeatureLists = gql`
  ${FullFeatureListFragment}

  query GetFullFeatureLists(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureListOrder]
    $where: FeatureListFilter
    $preview: Boolean
  ) {
    featureListCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFeatureListFragment
      }
    }
  }
`;
